import React from 'react'
import styled from 'styled-components'

// Constants
import { SKETCH_WEBSITE } from '@sketch/env-config'

// Styles
import { linkCss } from '../SignInToLinkAccountPage.styles'
import { Link } from '@sketch/components'

const StyledLink = styled(Link)`
  ${linkCss}
`

/**
 * Common links used in both Verification Code and Recovery Code UI
 */
export const HelpNote: React.FC = () => {
  return (
    <>
      Lost your recovery codes?{' '}
      <StyledLink
        external
        variant="tertiary"
        isUnderlined
        href={`${SKETCH_WEBSITE}/support/contact/`}
      >
        Contact us
      </StyledLink>
      <br />
    </>
  )
}

export default HelpNote
